import React from "react"

const QpLeftPanel = ({ fillColor, strokeColor }) => (
  <g id="left-panel">
    <path fill={fillColor} d="M161.187 593.653c0-.1 0-.2-.1-.3-1.5-8.1-11.3-132.6-12.6-187.2.7-5.5.699-14.2.399-24.1 1.7-17.2-2.199-42.7-4.799-56.9-5.5-1.1-9.2-1.9-10.5-2.2-9.7-2.2-124-43.9-124-43.9.5 10.9.9 22 1.5 33.2 4.4 96.8 10.3 196.8 10.3 196.8s0 36 34 57c18.5 11.4 72.199 32.6 117.399 49.6-4.2-6.7-10.599-17.9-11.599-22Z" />
    <path stroke={strokeColor} d="M161.187 593.653c0-.1 0-.2-.1-.3-1.5-8.1-11.3-132.6-12.6-187.2.7-5.5.699-14.2.399-24.1 1.7-17.2-2.199-42.7-4.799-56.9-5.5-1.1-9.2-1.9-10.5-2.2-9.7-2.2-124-43.9-124-43.9.5 10.9.9 22 1.5 33.2 4.4 96.8 10.3 196.8 10.3 196.8s0 36 34 57c18.5 11.4 72.199 32.6 117.399 49.6-4.2-6.7-10.599-17.9-11.599-22Z" strokeWidth="3" strokeMiterlimit="10"/>
  </g>
)

export default QpLeftPanel
